/**
 * ZEMİN ANAHTARLARI (kullanıcı kararı 02.11.2026): menü bölümüne göre sayfa
 * zemini ve sayfa içi bölümlerin ayrı tonları Ayarlar'dan ayrı ayrı açılıp
 * kapanır; ikisi de varsayılan AÇIK. Seçim kasanın şifreli ayarlarında durur
 * (eşitlemeyle öbür cihazlara gider). Kasa kapalıyken varsayılan görünüm.
 */

import { useEffect, useState } from "react";
import type { LocalRepository } from "@parafon/contracts/local-api";

export const MENU_ZEMINI_AYARI = "gorunum.menuZemini";
export const ICI_ZEMIN_AYARI = "gorunum.iciZemin";

export interface ZeminAyarlari {
  readonly menu: boolean;
  readonly ici: boolean;
}

export const VARSAYILAN_ZEMIN: ZeminAyarlari = { menu: true, ici: true };

export async function zeminAyarlariniOku(repo: LocalRepository): Promise<ZeminAyarlari> {
  const [menu, ici] = await Promise.all([repo.settings.get(MENU_ZEMINI_AYARI), repo.settings.get(ICI_ZEMIN_AYARI)]);
  return { menu: menu !== "0", ici: ici !== "0" };
}

export function useZeminAyarlari(repo: LocalRepository, revision: number): ZeminAyarlari {
  const [z, setZ] = useState<ZeminAyarlari>(VARSAYILAN_ZEMIN);
  useEffect(() => {
    let iptal = false;
    void zeminAyarlariniOku(repo).then(
      (v) => {
        if (!iptal) setZ(v);
      },
      () => undefined,
    );
    return () => {
      iptal = true;
    };
  }, [repo, revision]);
  return z;
}
